import { render } from "./promo-banner.vue?vue&type=template&id=b911ec66"
import script from "./promo-banner.vue?vue&type=script&lang=js"
export * from "./promo-banner.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__